import { Dispatch } from "react";
import { IModalContext } from "./newSectionModalContext";
import { Pen } from "../../../Definitions";

export type DevicePortsUsed = {[deviceId: number]: number[]};

export function dispatchTerminalConflict(dispatch: Dispatch<Deep_Partial<IModalContext>>, pens: Pen[], deviceOutputsUsed: DevicePortsUsed = {}, deviceInputsUsed: DevicePortsUsed = {} ) {
  let shouldDispatch = false;

  const pensForDispatch = pens.map((pen) => {
    if (pen.io === null) {
      return pen;      
    }    

    if (deviceOutputsUsed[pen.io] === undefined) {
      deviceOutputsUsed[pen.io] = [];
    }
    if (deviceInputsUsed[pen.io] === undefined) {
      deviceInputsUsed[pen.io] = [];
    }

    const OutputPortsUsed = deviceOutputsUsed[pen.io];
    const inputPortsUsed = deviceInputsUsed[pen.io];


    let blockedIos: {feederOutput: boolean, waterOutput?: boolean, activatorInput?: boolean} = {feederOutput: false}
    
    if (pen.feederOutput) {
      if (OutputPortsUsed.includes(pen.feederOutput)) {
       shouldDispatch = true;
       blockedIos.feederOutput = true;
      } else {
        OutputPortsUsed.push(pen.feederOutput);
      }

    if (pen.waterOutput) {
      if (OutputPortsUsed.includes(pen.waterOutput)) {
        shouldDispatch = true;
        blockedIos.waterOutput = true;
      } else {
        OutputPortsUsed.push(pen.waterOutput);
      }
    }
    if (pen.activatorInput) {
      if (inputPortsUsed.includes(pen.activatorInput)) {
        shouldDispatch = true;
        blockedIos.activatorInput = true;
      } else {
        inputPortsUsed.push(pen.activatorInput);
      }
    }
  }
    return {...pen, blockedIos}
  })
  if (shouldDispatch) {
    dispatch({section:{contents: pensForDispatch}})
  }
  return shouldDispatch;
} 